export default __webpack_public_path__ + "static/work-with-us-bg-324bbf3402f8f69d65c96a0cf504993e.jpg";